import { render, staticRenderFns } from "./SalabamVoliVadobay.vue?vue&type=template&id=2df5a228&scoped=true"
import script from "./SalabamVoliVadobay.vue?vue&type=script&lang=js"
export * from "./SalabamVoliVadobay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5a228",
  null
  
)

export default component.exports